import { Container, Row, Col } from "react-bootstrap";
import "./ManifestCreation.css";
import "react-datepicker/dist/react-datepicker.css";
import React, { useEffect, useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate"; // Import your configured axios instance
import { formatDate } from "../../utils/Utilities.js";
import useAuth from "../../hooks/useAuth";
import { useNavigate, Link } from "react-router-dom";
import useLogout from "../../hooks/useLogout";
import TopBar from "./TopBar";




const ManifestCreation = () => {
  const handleRedirect = () => {
    navigate("/GetManifestByDate");
  }

  // const [consignmentIds, setConsignmentIds] = useState(""); 

  const [selectedValues, setSelectedValues] = useState(""); // Store the selected values as string
  const GetConsignmentsToManifest_URL = "api/get-consignments-to-manifest"; // Replace with the correct API endpoint to fetch Consignments
  const [consignments, setConsignments] = useState([]); // To store list of Consignments
  const [selectedRows, setSelectedRows] = useState(new Set());

  const [loading, setLoading] = useState(true); // To show loading spinner while fetching
  const [error, setError] = useState(null); // To handle errors


  const { auth } = useAuth();
  const [destinationFranchiseId, setDestinationFranchiseId] = useState("");
  const [weight, setWeight] = useState("");
  const [manifestDate, setManifestDate] = useState("");
  const [consignmentIds, setConsignmentIds] = useState("");

  const [responseMessage, setResponseMessage] = useState("");

  const [message, setMessage] = useState("");
  const [manifestNumber, setManifestNumber] = useState("");


  const axiosPrivate = useAxiosPrivate();
  const CREATE_MANIFEST_URL = "/api/create-manifest"; // Replace with the correct API endpoint to fetch users
  const [validationError, setValidationError] = useState("");



  const fetchConsignments = async () => {
    try {
      const para = {
        franchise_id: auth.franchise_id,
      };

      const response = await axiosPrivate.get(GetConsignmentsToManifest_URL, {
        params: para,
      });

      console.log("API response for consignments:", response.data);

      // Safely extract an array from the response
      const consignmentsData = Array.isArray(response.data)
        ? response.data
        : response.data?.data ?? [];

      setConsignments(consignmentsData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Consignments:", error);
      setError("Failed to load Consignments");
      setLoading(false);
    }
  };




  useEffect(() => {
    fetchConsignments();
  }, []);




  const handleSelectFromTable = () => {
    if (selectedRows.size === 0) {
      setValidationError("Please select at least one consignment from the table.");
      return false;
    }

    const selectedData = consignments.filter((item) =>
      selectedRows.has(item.consignment_id)
    );
    const selectedDataString = selectedData
      .map((item) => `${item.consignment_id}`)
      .join(",");

    setSelectedValues(selectedDataString);
    setValidationError("");
    return true;
  };









  // Function to toggle selection of a single row
  const toggleRowSelection = (id) => {
    const newSelectedRows = new Set(selectedRows);
    if (newSelectedRows.has(id)) {
      newSelectedRows.delete(id);
    } else {
      newSelectedRows.add(id);
    }
    setSelectedRows(newSelectedRows);
  };

  // Function to toggle selection of all rows
  const toggleSelectAll = () => {
    if (selectedRows.size === consignments.length) {
      setSelectedRows(new Set()); // Deselect all
    } else {
      setSelectedRows(new Set(consignments.map((item) => item.consignment_id))); // Select all
    }
  };


  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage(null);
      }, 5000); // Hide after 5 seconds

      return () => clearTimeout(timer); // Cleanup
    }
  }, [message]);




  function addItemFromTableToField(consignments, selectedRows, setSelectedValues) {

    const selectedData = consignments.filter((item) =>
      selectedRows.has(item.consignment_id)
    );

    const selectedDataString = selectedData
      .map((item) => `${item.consignment_id}`)
      .join(",");

    setSelectedValues(selectedDataString);
  }



  // const postmanifest = async () => {
  //   const formattedDate = formatDate(manifestDate);
  //   // const consignmentIdsArray = consignmentIds
  //   const consignmentIdsArray =selectedValues
  //     .split(",")
  //     .map((id) => parseInt(id.trim(), 10));

  //   const body = {
  //     franchise_id: auth.franchise_id,
  //     destination_franchise_id: destinationFranchiseId,
  //     weight,
  //     manifest_date: formattedDate,
  //     consignment_ids: consignmentIdsArray,
  //   };
  //   console.log(body.consignment_ids);
  //   try {
  //     const response = await axiosPrivate.post(CREATE_MANIFEST_URL, body);
  //     setMessage(response.data.message); // Set the success message
  //     setManifestNumber(response.data.data.manifest_number); // Set the generated manifest number
  //     console.log(response.data.data.manifest_number)
  //   } catch (error) {
  //     // handleApiError(error); // Your existing error handling logic
  //   }
  // };

  // Handle form submission
  // const handleSubmit = async (event) => {

  //   event.preventDefault(); 
  //   postmanifest();

  //   fetchConsignments();
  //   ClearFields();

  // };

  const ClearFields = () => {
    setDestinationFranchiseId("");
    setWeight("");
    setManifestDate("");
    setSelectedValues("");
  };




  const navigate = useNavigate();
  const logout = useLogout();

  const signOut = async () => {
    await logout();
    navigate('/login');
  }

  return (
    <>

      <section className="manifestbody">
        <br />
        <div className="wrapper5">
          <div className="d-flex align-items-center">
            {/* Left */}
            <button
              onClick={() => navigate(-1)}
              className="btn btn-secondary newviewbtn"
            >
              ← Back
            </button>

            {/* Right */}
            <div className="d-flex gap-2 ms-auto">
              <button
                onClick={() => window.location.reload()}
                type="button"
                className="btn btn-success top-bt"
              >
                Create New
              </button>

              <button
                onClick={handleRedirect}
                type="button"
                className="btn btn-success top-bt"
              >
                Manifest List
              </button>
            </div>
          </div>


          {/* <button onClick={() => window.location.reload()} type="button" className="btn btn-success ms-auto d-block top-bt">Create New</button> */}
          {/* <center>
  <button className="btn reload-button" onClick={() => window.location.reload()}>
    Create New
  </button>
</center> */}
          {/* <form onSubmit={handleSubmit}> */}
          <form >
            <h3>Manifest Creation</h3>
            {message && (
              <div className="response-message success">
                <p>{message}</p>
                {manifestNumber && <p>Manifest Number: {manifestNumber}</p>}
              </div>
            )}
            {/* Form Fields */}
            <Row> <Col>
              <div className="input-boxs">
                <label htmlFor="destination_franchise_id">Destination franchise Id</label>
                <input
                  type="text"
                  id="destination_franchise_id"
                  placeholder=""
                  value={destinationFranchiseId}
                  onChange={(e) => setDestinationFranchiseId(e.target.value)}
                  required
                />
                {/* <i className="bx bxs-lock-alt"></i> */}
              </div>
            </Col>
              <Col>

                <div className="input-boxs">
                  <label htmlFor="weight">Weight  </label>
                  <input
                    type="text"
                    id="weight"
                    placeholder=""
                    onChange={(e) => setWeight(e.target.value)}
                    value={weight}
                    required
                  />
                  {/* <i className="bx bxs-lock-alt"></i> */}
                </div>
              </Col>
            </Row>
            <Row><Col>
              <div className="input-boxs">
                <label htmlFor="manifest_date">Manifest Date  </label>
                <input
                  type="date"
                  id="manifest_date"
                  onChange={(e) => setManifestDate(e.target.value)}
                  value={manifestDate}
                  required
                />
                {/* <i className="bx bxs-user"></i> */}
              </div>
            </Col>
              <Col>

                <div className="input-boxs" style={{ display: "none" }}>
                  <label htmlFor="consignment_ids">Consignment IDs  </label>
                  <input
                    type="text"
                    id="consignment_ids"
                    placeholder=""
                    value={selectedValues}
                    onChange={(e) => setSelectedValues(e.target.value)}
                  // required
                  />
                  {/* <i className="bx bxs-lock-alt"></i> */}
                </div>
              </Col></Row>

            <center>
              {/* <button type="submit" className="btn regbutton" onClick={() => addItemFromTableToField(consignments, selectedRows, setSelectedValues)}>
        Submit button
      </button> */}

            </center>
            <center>
              <button
                type="submit"
                className="btn regbutton"
                onClick={(e) => {
                  e.preventDefault();
                  const isValid = handleSelectFromTable(); // first: collect selections & validate
                  if (isValid) {
                    const selectedData = consignments.filter((item) =>
                      selectedRows.has(item.consignment_id)
                    );
                    const selectedDataString = selectedData
                      .map((item) => `${item.consignment_id}`)
                      .join(",");

                    const consignmentIdsArray = selectedDataString
                      .split(",")
                      .map((id) => parseInt(id.trim(), 10));

                    const formattedDate = formatDate(manifestDate);

                    const body = {
                      franchise_id: auth.franchise_id,
                      destination_franchise_id: destinationFranchiseId,
                      weight,
                      manifest_date: formattedDate,
                      consignment_ids: consignmentIdsArray,
                    };

                    axiosPrivate.post(CREATE_MANIFEST_URL, body).then((response) => {
                      setMessage(response.data.message);
                      setManifestNumber(response.data.data.manifest_number);
                      fetchConsignments();
                      ClearFields();
                    }).catch((error) => {
                      console.error("Post manifest error:", error);
                    });
                  }

                }}
              >
                Submit
              </button>
            </center>


            {validationError && (
              <div className="validation-error" style={{ color: "red", marginTop: "10px" }}>
                {validationError}
              </div>
            )}




          </form>
          <div className="table-container">
            <form>
              <table id="customers">
                <thead>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        onChange={toggleSelectAll}
                        checked={selectedRows.size === consignments.length} // Check if all rows are selected
                      />
                    </th>
                    <th>Cons. Id</th>
                    <th>AWB</th>
                    <th>Type</th>
                    <th>Goods name</th>
                    <th>Weight</th>

                    <th>Post office</th>
                    <th>Destination franchise</th>
                  </tr>
                </thead>
                <tbody>
                  {consignments.map((item) => (
                    <tr key={item.consignment_id}>
                      <td>
                        <center><input
                          type="checkbox"
                          checked={selectedRows.has(item.consignment_id)}
                          onChange={() => toggleRowSelection(item.consignment_id)}
                        /></center>
                      </td>
                      <td>{item.consignment_id}</td>
                      <td>{item.awb_number}</td>
                      <td>{item.consignment_type}</td>
                      <td>{item.goods_name}</td>
                      <td>{item.weight}</td>
                      <td> {item.post_office} - {item.pincode}</td>
                      <td>{item.destination_franchise_code} - {item.destination_franchise_name}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </form>
          </div>

        </div>

        {/* Display API Response */}

      </section>




      <TopBar />

    </>
  );
};

export default ManifestCreation;
